import React, { useCallback, useEffect } from 'react';

import { useMutation } from '@sopranodesign/pulse-hooks';
import { Flex, Heading1, Paragraph } from '@sopranodesign/pulse-components';

import { logout } from '../api/auth';
import { useAuth } from '../hooks/index';
import { LoggedOutRedirect } from '../Components/index';

const Logout = () => {
  const { authenticated, logoutUser } = useAuth();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: logout,
    onSuccess: ({ data }) => {
      return logoutUser(data.redirect);
    }
  });

  const handleLogout = useCallback(() => {
    !isPending && !isSuccess && mutate();
  }, [isPending, isSuccess, mutate]);

  useEffect(() => {
    if (authenticated) {
      handleLogout();
    }
  }, [authenticated, handleLogout]);

  return (
    <Flex col fat="true" yScreen center middle pad>
      {!authenticated && <LoggedOutRedirect />}
      <Heading1 style={{ fontSize: '2rem' }} mb textCenter>
        Logging you out
      </Heading1>
      <Paragraph secondary textCenter>
        Please wait and you will be logged out
      </Paragraph>
    </Flex>
  );
};

export default Logout;
